var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JwChat-index',{attrs:{"config":_vm.config,"showRightBox":true,"scrollType":"noroll","taleList":_vm.taleList,"toolConfig":_vm.tool,"winBarConfig":_vm.winBarConfig},on:{"enter":_vm.bindEnter,"clickTalk":_vm.talkEvent},model:{value:(_vm.inputMsg),callback:function ($$v) {_vm.inputMsg=$$v},expression:"inputMsg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }